import React from 'react'

import { ApprovedIcon, IconContainer, PendingIcon, RejectedIcon } from 'modules/requests/filters/StatusFilter.styles'
import {
  DataAccessRequestReviewSubStatus,
  DataAccessRequestStatus as DataAccessRequestStatusEnum
} from 'services/data-access-requests/enums'

interface DataAccessRequestStatusProps {
  reviewSubStatus?: DataAccessRequestReviewSubStatus
  status: DataAccessRequestStatusEnum
}

export const DataAccessRequestStatus = ({
  reviewSubStatus,
  status
}: DataAccessRequestStatusProps): JSX.Element | null => {
  switch (status) {
    case DataAccessRequestStatusEnum.PendingVerification:
      return (
        <IconContainer>
          <PendingIcon />
          <span>Pending</span>
        </IconContainer>
      )
    case DataAccessRequestStatusEnum.Approved:
      return (
        <IconContainer>
          <ApprovedIcon />
          <span>Approved</span>
        </IconContainer>
      )
    case DataAccessRequestStatusEnum.Rejected:
      return (
        <IconContainer>
          <RejectedIcon />
          <span>
            Rejected
            {reviewSubStatus === DataAccessRequestReviewSubStatus.AdditionalInformationRequired
              ? ' · Additional information required'
              : ''}
          </span>
        </IconContainer>
      )
    default:
      return null
  }
}
